import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {environment} from 'environments/environment';

import {LogService} from 'app/services/log.service';

@Injectable()
export class ErrorsHandler implements ErrorHandler {

  constructor(private injector: Injector) { }

  handleError(error: any): void {
    if (!environment.production) {
      console.error('ErrorsHandler: ', error);
    }
    // Client Error (Angular, ReferenceError...)
    if (error instanceof Error && !error.message.includes('ExpressionChangedAfterItHasBeenCheckedError')) {
      if (!environment.production) {
        console.error('ErrorsHandler - error instanceof Error');
      }
      const logService = this.injector.get(LogService);
      logService
        .log(error)
        .subscribe(logError => logService.showInErrorComponent(logError));

    }
  }
}
